import { TemplateEngine } from "../../../../js/lib/TemplateEngine";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";

    export class TwirlDown {
    constructor(id, headerText) {
        this.id = id;
        this.headerText = headerText;
        this.isOpen = false;
        this.target = null;
    }
    init(target, callback) {
        this.target = target;
        this.target.off("click", "#" + this.id + " .toggle");
        target.on("click", "#" + this.id + " .toggle", null, this._getToggleHandler());
        TemplateEngine.fetch("tmpl/controls/TwirlDown.html", target, this, callback);

    }
    destroy() {
        this.target.off("click", "#" + this.id + " .toggle");
        this.target.find("#" + this.id).remove();
        this.target = null;
    }
    _getToggleHandler() {
        var _this = this;
        return function toggleHandler() {
            _this.toggle();
            return false;
        };
    }
    setContent(content) {
        this.getContentContainer().html(content);
    }
    setHeaderText(headerText) {
        $("#" + this.id + " .toggle-header-text").text(headerText);
    }
    _toggle() {
        var toggleLink = this._getToggleLink();
        if (toggleLink.hasClass(LS2PAC_CONSTANTS.CssClasses.open)) {
            toggleLink.removeClass(LS2PAC_CONSTANTS.CssClasses.open);
            this.isOpen = false;
        } else {
            toggleLink.addClass(LS2PAC_CONSTANTS.CssClasses.open);
            this.isOpen = true;
        }
        this.getContentContainer().slideToggle(600);
    }
    _getToggleLink() {
        return $("#" + this.id + " .toggle");
    }
    getContentContainer() {
        return $("#" + this.id + "_content");
    }
    toggle() {
        this._toggle();
    }
    open() {
        this._getToggleLink().addClass(LS2PAC_CONSTANTS.CssClasses.open);
        this.getContentContainer().slideToggle(600);
        this.isOpen = true;
    }
    close() {
        this._getToggleLink().removeClass(LS2PAC_CONSTANTS.CssClasses.open);
        this.getContentContainer().slideToggle(600);
        this.isOpen = false;
    }
    show() {
        $("#" + this.id).show();
    }
    hide() {
        $("#" + this.id).hide();
    }
}













